import styles from "./template-selection.module.css";
import classNames from "classnames";
import { AiLoader } from "frontend/canvas-designer-new/ai-generator/ai-loader/ai-loader";
import { useState } from "react";

const StaticLoader = () => {
  return (
    <svg width="63" height="48" viewBox="0 0 68 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#paint0_angular_1_20_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0 0.0225003 -0.0225003 0 26.4709 26.4709)">
          <foreignObject x="-1027.69" y="-1027.69" width="2055.38" height="2055.38">
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,rgba(220, 122, 245, 1) 0deg,rgba(221, 165, 254, 1) 56.3766deg,rgba(246, 220, 255, 1) 149.977deg,rgba(161, 71, 245, 1) 191.377deg,rgba(205, 135, 255, 1) 230.977deg,rgba(242, 223, 255, 1) 308.377deg,rgba(220, 122, 245, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M24.0278 5.9458C24.4164 4.75821 25.5072 3.9764 26.7546 3.97064C28.0052 3.99957 29.0982 4.80751 29.4639 6.01813L33.0321 17.8331L33.0338 17.839C33.3564 18.9278 34.1852 19.727 35.1974 20.084L46.979 23.9733C48.1832 24.3939 48.9656 25.4935 48.9712 26.7718C48.9423 28.0196 48.1348 29.1121 46.922 29.478L35.0984 33.0435L35.0923 33.0453C34.0038 33.3675 33.2038 34.1952 32.8463 35.2075L28.9505 46.9916L28.949 46.996C28.5591 48.188 27.4595 48.9712 26.2063 48.9712H26.1537C24.9026 48.9429 23.8088 48.1347 23.4429 46.9237L19.8748 35.1087L19.8731 35.103C19.5505 34.0141 18.7217 33.2149 17.7094 32.8579L5.95306 28.9653L5.94738 28.9635C4.77701 28.5811 3.97636 27.4705 3.97064 26.1701C3.99947 24.9367 4.82853 23.8321 6.02335 23.4628L17.8837 19.8967C18.9727 19.5748 19.7729 18.7469 20.1306 17.7343L24.0264 5.95021L24.0278 5.9458Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:2.7554909275259633e-15,&#34;m01&#34;:-45.000579833984375,&#34;m02&#34;:48.971218109130859,&#34;m10&#34;:45.000606536865234,&#34;m11&#34;:2.7554926215918579e-15,&#34;m12&#34;:3.9706382751464844},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        stroke="url(#paint1_linear_1_20)"
        strokeWidth="0.623018"
      />
      <g clipPath="url(#paint2_angular_1_20_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0 0.00994732 -0.00994732 0 55.8759 11.7027)">
          <foreignObject x="-1026.84" y="-1026.84" width="2053.68" height="2053.68">
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,rgba(220, 122, 245, 1) 0deg,rgba(221, 165, 254, 1) 56.3766deg,rgba(246, 220, 255, 1) 149.977deg,rgba(161, 71, 245, 1) 191.377deg,rgba(205, 135, 255, 1) 230.977deg,rgba(242, 223, 255, 1) 308.377deg,rgba(220, 122, 245, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M54.7958 2.62862C54.9676 2.10359 55.4498 1.75796 56.0013 1.75541C56.5542 1.7682 57.0374 2.12539 57.1991 2.6606L58.7765 7.88397L58.7773 7.88659C58.9199 8.36794 59.2863 8.72124 59.7338 8.87907L64.9424 10.5985C65.4748 10.7845 65.8207 11.2706 65.8232 11.8358C65.8104 12.3874 65.4534 12.8704 64.9173 13.0322L59.6901 14.6085L59.6874 14.6093C59.2061 14.7517 58.8525 15.1176 58.6944 15.5652L56.9721 20.7749L56.9714 20.7768C56.799 21.3038 56.3129 21.6501 55.7589 21.6501H55.7356C55.1825 21.6375 54.699 21.2802 54.5372 20.7448L52.9597 15.5215L52.959 15.5189C52.8164 15.0375 52.45 14.6842 52.0024 14.5264L46.805 12.8055L46.8025 12.8047C46.2851 12.6356 45.9311 12.1446 45.9286 11.5697C45.9413 11.0244 46.3078 10.5361 46.8361 10.3728L52.0795 8.7963C52.5609 8.65397 52.9147 8.28795 53.0728 7.84029L54.7952 2.63057L54.7958 2.62862Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.86666667461395264,&#34;g&#34;:0.64705884456634521,&#34;b&#34;:0.99607843160629272,&#34;a&#34;:1.0},&#34;position&#34;:0.15660156309604645},{&#34;color&#34;:{&#34;r&#34;:0.96785920858383179,&#34;g&#34;:0.86607944965362549,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.41660156846046448},{&#34;color&#34;:{&#34;r&#34;:0.63281941413879395,&#34;g&#34;:0.28060704469680786,&#34;b&#34;:0.96230846643447876,&#34;a&#34;:1.0},&#34;position&#34;:0.53160154819488525},{&#34;color&#34;:{&#34;r&#34;:0.80495357513427734,&#34;g&#34;:0.53188854455947876,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.64160156250},{&#34;color&#34;:{&#34;r&#34;:0.95267170667648315,&#34;g&#34;:0.87471830844879150,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.85660153627395630},{&#34;color&#34;:{&#34;r&#34;:0.86274510622024536,&#34;g&#34;:0.47843137383460999,&#34;b&#34;:0.96078431606292725,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:1.2181950555654911e-15,&#34;m01&#34;:-19.894634246826172,&#34;m02&#34;:65.823196411132812,&#34;m10&#34;:19.894647598266602,&#34;m11&#34;:1.2181959025984383e-15,&#34;m12&#34;:1.7554092407226562},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        stroke="url(#paint3_linear_1_20)"
        strokeWidth="0.267008"
      />
      <defs>
        <clipPath id="paint0_angular_1_20_clip_path">
          <path
            d="M24.0278 5.9458C24.4164 4.75821 25.5072 3.9764 26.7546 3.97064C28.0052 3.99957 29.0982 4.80751 29.4639 6.01813L33.0321 17.8331L33.0338 17.839C33.3564 18.9278 34.1852 19.727 35.1974 20.084L46.979 23.9733C48.1832 24.3939 48.9656 25.4935 48.9712 26.7718C48.9423 28.0196 48.1348 29.1121 46.922 29.478L35.0984 33.0435L35.0923 33.0453C34.0038 33.3675 33.2038 34.1952 32.8463 35.2075L28.9505 46.9916L28.949 46.996C28.5591 48.188 27.4595 48.9712 26.2063 48.9712H26.1537C24.9026 48.9429 23.8088 48.1347 23.4429 46.9237L19.8748 35.1087L19.8731 35.103C19.5505 34.0141 18.7217 33.2149 17.7094 32.8579L5.95306 28.9653L5.94738 28.9635C4.77701 28.5811 3.97636 27.4705 3.97064 26.1701C3.99947 24.9367 4.82853 23.8321 6.02335 23.4628L17.8837 19.8967C18.9727 19.5748 19.7729 18.7469 20.1306 17.7343L24.0264 5.95021L24.0278 5.9458Z"
            strokeWidth="0.623018"
          />
        </clipPath>
        <clipPath id="paint2_angular_1_20_clip_path">
          <path
            d="M54.7958 2.62862C54.9676 2.10359 55.4498 1.75796 56.0013 1.75541C56.5542 1.7682 57.0374 2.12539 57.1991 2.6606L58.7765 7.88397L58.7773 7.88659C58.9199 8.36794 59.2863 8.72124 59.7338 8.87907L64.9424 10.5985C65.4748 10.7845 65.8207 11.2706 65.8232 11.8358C65.8104 12.3874 65.4534 12.8704 64.9173 13.0322L59.6901 14.6085L59.6874 14.6093C59.2061 14.7517 58.8525 15.1176 58.6944 15.5652L56.9721 20.7749L56.9714 20.7768C56.799 21.3038 56.3129 21.6501 55.7589 21.6501H55.7356C55.1825 21.6375 54.699 21.2802 54.5372 20.7448L52.9597 15.5215L52.959 15.5189C52.8164 15.0375 52.45 14.6842 52.0024 14.5264L46.805 12.8055L46.8025 12.8047C46.2851 12.6356 45.9311 12.1446 45.9286 11.5697C45.9413 11.0244 46.3078 10.5361 46.8361 10.3728L52.0795 8.7963C52.5609 8.65397 52.9147 8.28795 53.0728 7.84029L54.7952 2.63057L54.7958 2.62862Z"
            strokeWidth="0.267008"
          />
        </clipPath>
        <linearGradient
          id="paint1_linear_1_20"
          x1="17.1282"
          y1="6.22876"
          x2="35.8135"
          y2="49.8279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_20"
          x1="51.7455"
          y1="2.75372"
          x2="60.0062"
          y2="22.0288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const Background = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="127" height="102" viewBox="0 0 127 102" fill="none">
      <g clipPath="url(#clip0_829_13760)">
        <mask
          id="mask0_829_13760"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="127"
          height="157"
        >
          <rect width="127" height="157" rx="9" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_829_13760)">
          <foreignObject x="0" y="0" width="0" height="0">
            <div
              style={{
                backdropFilter: "blur(9.75px)",
                clipPath: "url(#bgblur_1_829_13760_clip_path)",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </foreignObject>
          <g data-figma-bg-blur-radius="19.5087">
            <rect width="127" height="102" rx="9" fill="white" />
            <rect
              x="0.75"
              y="0.75"
              width="125.5"
              height="100.5"
              rx="8.25"
              stroke="url(#paint0_linear_829_13760)"
              strokeOpacity="0.5"
              strokeWidth="1.5"
            />
          </g>
          <g opacity="0.4">
            <g filter="url(#filter0_f_829_13760)">
              <ellipse cx="82.9544" cy="41.4431" rx="16.7083" ry="12.1619" fill="#89BCFF" />
            </g>
            <g filter="url(#filter1_f_829_13760)">
              <ellipse cx="59.4437" cy="51.6072" rx="24.7045" ry="17.9822" fill="#FF86E1" />
            </g>
          </g>
          <g opacity="0.4">
            <g filter="url(#filter2_f_829_13760)">
              <ellipse cx="83.4154" cy="22.6913" rx="19.7997" ry="14.412" fill="#89BCFF" />
            </g>
            <g filter="url(#filter3_f_829_13760)">
              <ellipse cx="55.554" cy="34.737" rx="29.2752" ry="21.3092" fill="#FF86E1" />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="bgblur_1_829_13760_clip_path" transform="translate(0 0)">
          <rect width="127" height="102" rx="9" />
        </clipPath>
        <filter
          id="filter0_f_829_13760"
          x="9.34956"
          y="-27.6153"
          width="147.21"
          height="138.117"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="28.4483" result="effect1_foregroundBlur_829_13760" />
        </filter>
        <filter
          id="filter1_f_829_13760"
          x="-60.0883"
          y="-61.2026"
          width="239.064"
          height="225.62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="47.4138" result="effect1_foregroundBlur_829_13760" />
        </filter>
        <filter
          id="filter2_f_829_13760"
          x="6.71919"
          y="-48.6172"
          width="153.392"
          height="142.617"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="28.4483" result="effect1_foregroundBlur_829_13760" />
        </filter>
        <filter
          id="filter3_f_829_13760"
          x="-68.5488"
          y="-81.3998"
          width="248.205"
          height="232.273"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="47.4138" result="effect1_foregroundBlur_829_13760" />
        </filter>
        <linearGradient
          id="paint0_linear_829_13760"
          x1="-6.40632"
          y1="-7.97959"
          x2="136.373"
          y2="-3.61553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A148F5" />
          <stop offset="0.168269" stopColor="#CD88FF" />
          <stop offset="0.509615" stopColor="#FF56DA" />
          <stop offset="0.850962" stopColor="#8EBAFE" />
        </linearGradient>
        <clipPath id="clip0_829_13760">
          <rect width="127" height="102" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default function AISelectionCard({ onClick }: { onClick: () => void }) {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div
      className={styles.templateCard}
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className={classNames(styles.iconContainer, styles.aiCardContainer)}>
        <div className={styles.backgroundLayer}>
          <Background />
        </div>
        <div className={styles.loaderLayer}>
          {isHovering ? (
            <div className={styles.aiLoaderWrapper}>
              <AiLoader />
            </div>
          ) : (
            <StaticLoader />
          )}
        </div>
      </div>
      <span className={styles.templateName}>Make a wish</span>
      <div className={styles.templateCardBottom} />
    </div>
  );
}
